import React from 'react'
import { useWalletContext } from '../../WalletContext'
import { isSufficientBalanceInWallet } from '../../../model/tokens/helper'
import TokenSelectorNew from '../../TokenSelectorNew/TokenSelectorNew'
import { useStoreState } from '../../../model/hooks'

function DepositStep(props: {
    renderActionButton: () => JSX.Element | null | undefined
    totalAmount: string
    renderOutOfRangeInput: (token: string, isAbove: boolean) => JSX.Element | null | undefined
    renderStepIdentifier: (number: number, isDisabled: boolean) => JSX.Element
    handleToken2Select: (address: string) => void
    handleToken1Select: (address: string) => void
    handleTokenAmountChange: (token: string, amount: string) => void
    stepNumber: number
    token1: string
    token2: string
    token1Amount: string
    token2Amount: string
    isTokensReversedFromPool: boolean
    currentTick: number
    minTick: number
    maxTick: number
}) {
    const {
        renderActionButton,
        totalAmount,
        renderOutOfRangeInput,
        stepNumber,
        renderStepIdentifier,
        token1,
        token2,
        isTokensReversedFromPool,
        token1Amount,
        token2Amount,
        handleToken2Select,
        handleToken1Select,
        handleTokenAmountChange,
        currentTick,
        maxTick,
        minTick
    } = props
    const { networkName: network } = useWalletContext()
    const tokens = useStoreState((state) => state.tokens.getTokensList(network!))
    const getToken = useStoreState((state) => state.tokens.getToken)

    function renderTokenSelector(
        token: string,
        tokenAmount: string,
        otherToken: string,
        handleTokenSelect: any,
        handleTokenAmountChange: any,
        tokenSelectName: string,
        className = '',
        isInputDisabled = false
    ) {
        return (
            <div
                className={`px-4 py-[6px]  ${className}`}
                style={{
                    background: isSufficientBalanceInWallet(network!, token, tokenAmount) ? '#1D285A' : 'rgba(255, 83, 83, 0.2)',
                    borderRadius: '8px',
                    boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)'
                }}>
                <div className='flex justify-between'>
                    <div className='flex flex-1'>
                        <TokenSelectorNew
                            size={'sm'}
                            tokenAmount={tokenAmount}
                            error={isSufficientBalanceInWallet(network!, token, tokenAmount) ? '' : 'Exceeds Balance'}
                            network={network!}
                            token={token}
                            tokenStr={tokenSelectName}
                            otherToken={otherToken}
                            tokens={tokens}
                            handleTokenSelect={handleTokenSelect}
                            showMaxButton={true}
                            isSelectDisabled={true}
                            handleTokenAmountChange={handleTokenAmountChange}
                            inputs={
                                <input
                                    className={`bg-transparent p-1 text-[16px] text-right outline-none w-full lg:max-w-auto ${isInputDisabled ? 'text-gray' : 'text-white'}`}
                                    disabled={isInputDisabled}
                                    placeholder='0.00'
                                    value={tokenAmount}
                                    onChange={(e) => handleTokenAmountChange(token, e.target.value)}
                                />
                            }
                        />
                    </div>
                </div>
            </div>
        )
    }

    function renderStepDeposit() {
        if (stepNumber !== 4) {
            return (
                <div className='flex items-center mt-4 lg:mt-0'>
                    {renderStepIdentifier(3, true)}
                    <span className='text-[18px] text-[#3A4164] font-bold ml-4 opacity-[0.5]'>Liquidity</span>
                </div>
            )
        }
        const token1Obj = getToken(network!, token1)
        const token2Obj = getToken(network!, token2)
        const isToken0Disabled = isTokensReversedFromPool ? currentTick < minTick : currentTick > maxTick
        const isToken1Disabled = isTokensReversedFromPool ? currentTick > maxTick : currentTick < minTick
        let enabledSymbol = ''
        if (isToken0Disabled) enabledSymbol = token2Obj?.symbol!
        if (isToken1Disabled) enabledSymbol = token1Obj?.symbol!
        return (
            <div className='flex flex-col'>
                <div className='flex items-center mb-2 mt-2 lg:mt-0'>
                    {renderStepIdentifier(3, false)}
                    {/* <div className='ml-4  flex flex-col '> */}
                    <span className='ml-4 text-[18px] text-white font-bold block '>Liquidity</span>
                    {/* </div> */}
                </div>
                <span className='text-white opacity-[0.5] text-[14px] mb-2'>Token supply may not consistently maintain a 50:50 ratio within your selected range</span>

                {isToken0Disabled
                    ? null
                    : renderTokenSelector(
                          token1,
                          token1Amount,
                          token2,
                          handleToken1Select,
                          handleTokenAmountChange,
                          '',
                          '',
                          isTokensReversedFromPool ? currentTick < minTick : currentTick > maxTick
                      )}
                {isToken1Disabled
                    ? null
                    : renderTokenSelector(
                          token2,
                          token2Amount,
                          token1,
                          handleToken2Select,
                          handleTokenAmountChange,
                          '',
                          isToken0Disabled ? '' : 'mt-2',
                          isTokensReversedFromPool ? currentTick > maxTick : currentTick < minTick
                      )}

                {isToken0Disabled || isToken1Disabled ? renderOutOfRangeInput(enabledSymbol, isToken1Disabled) : null}
                <div className='text-6 flex justify-between p-4 mt-4'>
                    <span className='text-[18px]'>Total</span>
                    <span className='text-[18px]'>{totalAmount}</span>
                </div>

                {renderActionButton()}
            </div>
        )
    }

    return renderStepDeposit()
}

export default DepositStep
